export const SECTION_INFO_KEY = 'resume_distribution_info_section'
export const TRANSLATION = 'builder.resume_distribution.dashboard.banner'
